import(/* webpackMode: "eager" */ "/vercel/path0/app/free-study-planner/page.tsx");
